// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ButtonActions_wrapper__22psq {\n  display: flex; }\n  .ButtonActions_wrapper__22psq > * {\n    margin-right: 8px; }\n    .ButtonActions_wrapper__22psq > *:last-child {\n      margin-right: 0; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "ButtonActions_wrapper__22psq"
};
module.exports = exports;
